export default {
  "de": {
    "components-order-history": {
      "APPROVED": "GENEHMIGT",
      "CANCELLED": "STORNIERT",
      "ERROR PAYMENT": "FEHLERHAFTE ZAHLUNG",
      "NEW": "NEU",
      "ORDER CONFIRMED": "BESTELLUNG BESTÄTIGT",
      "Order Date": "Bestelldatum",
      "Order Number": "Bestellnummer",
      "ORDER RECEIVED": "BESTELLUNG ERHALTEN",
      "ORDER REJECTED": "BESTELLUNG ABGELEHNT",
      "PARTIAL APPROVED": "TEILWEISE GENEHMIGT",
      "SHIPPED": "VERSANDT",
      "Start/View a Return": "Rückgabe starten/anzeigen",
      "Status": "Status",
      "Subtotal": "Summe",
      "Total": "Gesamt",
      "Tracking No": "Sendungsverfolgungsnummer"
    }
  },
  "en": {
    "components-order-history": {
      "APPROVED": "APPROVED",
      "CANCELLED": "CANCELLED",
      "ERROR PAYMENT": "ERROR PAYMENT",
      "NEW": "NEW",
      "ORDER CONFIRMED": "ORDER CONFIRMED",
      "Order Date": "Order Date",
      "Order Number": "Order Number",
      "ORDER RECEIVED": "ORDER RECEIVED",
      "ORDER REJECTED": "ORDER REJECTED",
      "PARTIAL APPROVED": "PARTIAL APPROVED",
      "SHIPPED": "SHIPPED",
      "Start/View a Return": "Start/View a Return",
      "Status": "Status",
      "Subtotal": "Subtotal",
      "Total": "Total",
      "Tracking No": "Tracking No"
    }
  },
  "es": {
    "components-order-history": {
      "APPROVED": "APROBADO",
      "CANCELLED": "CANCELADO",
      "ERROR PAYMENT": "ERROR DE PAGO",
      "NEW": "NUEVO",
      "ORDER CONFIRMED": "PEDIDO CONFIRMADO",
      "Order Date": "Fecha de pedido",
      "Order Number": "Número de pedido",
      "ORDER RECEIVED": "PEDIDO RECIBIDO",
      "ORDER REJECTED": "PEDIDO RECHAZADO",
      "PARTIAL APPROVED": "PARCIALMENTE APROBADO ",
      "SHIPPED": "ENVIADO",
      "Start/View a Return": "Empezar/Ver una devolución",
      "Status": "Estado",
      "Subtotal": "Subtotal",
      "Total": "Total",
      "Tracking No": "N.º de seguimiento"
    }
  },
  "fr": {
    "components-order-history": {
      "APPROVED": "APPROUVÉ",
      "CANCELLED": "ANNULÉ",
      "ERROR PAYMENT": "ERREUR DE PAIEMENT",
      "NEW": "NOUVEAU",
      "ORDER CONFIRMED": "COMMANDE CONFIRMÉE",
      "Order Date": "Date de commande",
      "Order Number": "Numéro de commande",
      "ORDER RECEIVED": "COMMANDE REÇUE",
      "ORDER REJECTED": "COMMANDE REJETÉE",
      "PARTIAL APPROVED": "APPROBATION PARTIELLE",
      "SHIPPED": "EXPÉDIÉ",
      "Start/View a Return": "Effectuer/Consulter un retour",
      "Status": "Statut",
      "Subtotal": "Sous-total",
      "Total": "Total",
      "Tracking No": "Numéro de suivi"
    }
  },
  "jp": {
    "components-order-history": {
      "APPROVED": "承認",
      "CANCELLED": "取消",
      "ERROR PAYMENT": "支払エラー",
      "NEW": "新規",
      "ORDER CONFIRMED": "注文確定済",
      "Order Date": "注文日",
      "Order Number": "注文番号",
      "ORDER RECEIVED": "注文受領",
      "ORDER REJECTED": "注文拒否",
      "PARTIAL APPROVED": "一部承認",
      "SHIPPED": "発送済",
      "Start/View a Return": "返品手続きを開始する/見る",
      "Status": "ステータス",
      "Subtotal": "小計",
      "Total": "合計",
      "Tracking No": "追跡番号"
    }
  },
  "no": {
    "components-order-history": {
      "APPROVED": "GODKJENT",
      "CANCELLED": "KANSELLERT",
      "ERROR PAYMENT": "FEILBETALING",
      "NEW": "NY",
      "ORDER CONFIRMED": "ORDRE BEKREFTET",
      "Order Date": "Bestillingsdato",
      "Order Number": "Bestillingsnummer",
      "ORDER RECEIVED": "ORDRE MOTTAT",
      "ORDER REJECTED": "ORDRE AVVIST",
      "PARTIAL APPROVED": "DELVIS GODKJENT",
      "SHIPPED": "SENDT",
      "Start/View a Return": "Start/Vis en retur",
      "Status": "Status",
      "Subtotal": "Totalt",
      "Total": "Sum",
      "Tracking No": "Sporingsnr."
    }
  },
  "zh": {
    "components-order-history": {
      "APPROVED": "已核准",
      "CANCELLED": "已取消",
      "ERROR PAYMENT": "付款出错",
      "NEW": "新订单",
      "ORDER CONFIRMED": "订单已确认",
      "Order Date": "订单日期",
      "Order Number": "订单号",
      "ORDER RECEIVED": "订单已接收",
      "ORDER REJECTED": "订单已拒绝",
      "PARTIAL APPROVED": "部分核准",
      "SHIPPED": "已发货",
      "Start/View a Return": "开始/查看退货",
      "Status": "状态",
      "Subtotal": "小计",
      "Total": "总价",
      "Tracking No": "追踪编号"
    }
  }
};
